/** Notification template management (14 slots: 7 SMS + 2 EMAIL + 5 WhatsApp). */
import { endpoints } from '@/config/env';
import type { NotificationTemplate, TemplateChannel } from '@/types';
import { request } from './client';

export function fetchTemplates(signal?: AbortSignal): Promise<NotificationTemplate[] | null> {
  return request<NotificationTemplate[] | null>(endpoints.notificationTemplates(), { signal });
}

export function upsertTemplate(template: {
  templateKey: string;
  channel: TemplateChannel;
  body: string;
  subject?: string | null;
  language?: string;
  isActive?: boolean;
}): Promise<NotificationTemplate | null> {
  return request<NotificationTemplate | null>(endpoints.notificationTemplates(), {
    method: 'PUT',
    body: template,
  });
}

export function deleteTemplateOverride(templateKey: string, channel: TemplateChannel): Promise<null> {
  return request<null>(endpoints.notificationTemplate(templateKey, channel), { method: 'DELETE' });
}
